import * as types from "./mutation-types";

export const fetchCategoriesWithProducts = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`pos/get/categories/with/products`)
            .then(response => {
                commit(types.LOAD_CATEGORIES_WITH_PRODUCTS, response.data.categories)
                resolve(response);
            })
            .catch(error => {
                reject(error.response.data);
            });
    });
}



export const fetchCustomers = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('pos/get/customers')
            .then(response => {
                commit(types.SET_CUSTOMERS, response.data)
                return response.data
            })
            .catch(error => {
                reject(error);
            });
    });
}

export const createCustomer = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/contact', data)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error);
            });
    });
}

export const fetchPaymentMethods = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('pos/get/payment-methods')
            .then(response => {
                commit(types.SET_PAYMENT_METHODS, response.data.payment_methods)
                resolve(response.data.payment_methods)
            })
            .catch(error => {
                reject(error);
            });
    });
}

export const checkout = ({ commit }, checkoutData) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`pos/checkout`, checkoutData)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
    });
}

export const checkStock = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('pos/product/check/quantity', data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
    });
}

export const checkBundleStock = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('pos/bundle/check/quantity', data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
    });
}

export const fetchProductsByShop = async ({ commit }, { shop }) => {
    const response = await window.axios.get(
        `admin/get/shop/${shop}/product/collection`
    );
    console.log(response)

    commit(types.SET_PRODUCTS, response?.data?.shop_products);

    return response;
};

let stockChannelName = null

export const listenStockUpdates = ({ dispatch }, shopId) => {
    if (!window.Echo || !shopId) return

    stockChannelName = `shop.${shopId}.products`
    window.Echo.channel(stockChannelName)
        .listen('.ShopProductStockUpdated', () => {
            dispatch('fetchCategoriesWithProducts')
        })
}

export const stopListeningStockUpdates = () => {
    if (!window.Echo || !stockChannelName) return

    window.Echo.leaveChannel(stockChannelName)
    stockChannelName = null
}

export const sendInvoiceByEmail = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/shop/checkout/${data.id}/send/email`, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
    });
}

export const sendInvoiceByPhone = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/shop/checkout/${data.id}/send/from/whatsapp`, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
    });
}

export const getInvoiceWhatsAppShareLink = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/shop/checkout/${data.id}/whatsapp/share-link`, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
    });
}